import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import './styles/formstepper.scss';

class FormEditSteps extends Component {
  renderSteps() {
    const { steps, currentStep } = this.props;
    const renderedSteps = [];

    steps.forEach((step, index) => {
      const current = currentStep === index;
      const finished = currentStep > index;

      const className = classNames({
        'step-num': true,
        current,
        finished,
      });

      if (!finished) {
        renderedSteps.push(
          <div key={`step-${index}`} className={className}>
            {index + 1}
          </div>
        );
      } else {
        renderedSteps.push(
          <div
            key={`step-${index}`}
            className={className}
            onClick={() => {
              this.props.jump(index);
            }}
          >
            <i className="zmdi zmdi-check zmdi-hc-lg" />
          </div>
        );
      }

      if (step && current) {
        renderedSteps.push(
          <div key={`label-${index}`} className="step-label">
            {step}
          </div>
        );
      }

      if (index + 1 !== steps.length) {
        renderedSteps.push(<div key={`line-${index}`} className="step-line" />);
      }
    });

    return (
      <div className="step-items">
        <div className="step-progress">{renderedSteps}</div>
      </div>
    );
  }

  render() {
    return <div className="form-edit-stepper">{this.renderSteps()}</div>;
  }
}

FormEditSteps.defaultProps = {
  currentStep: 0,
  steps: [],
  jump: () => {},
};

FormEditSteps.propTypes = {
  currentStep: PropTypes.number,
  steps: PropTypes.array,
  jump: PropTypes.func,
};

export default FormEditSteps;
